import { h, Component } from 'preact';
import StockDetailsPage from '../stock-details-page';
import AnnualQuarterlySelector from '../annual-quarterly-selector';
import FinancialDetailsTabs from './financial-details-tabs';
import style from './style';
import * as constants from '../annual-quarterly-selector/constants';

export default class IncomeCashBalancePanel extends Component {
	state = {
		timespan: constants.QUARTERLY
	};

	handleChangeTimeRange = ({ value: timespan = '' }) => {
		this.setState({ timespan: timespan.toLowerCase() });
	};

	render(props, { timespan }) {
		return (
			<StockDetailsPage {...props}>
				<AnnualQuarterlySelector class={style.floatRight} value={timespan} onChange={this.handleChangeTimeRange} />
				<FinancialDetailsTabs timespan={timespan} {...props} />
			</StockDetailsPage>
		);
	}
}
